import { useContext } from "react";
import { OlympiadPageContext } from "../contexts/olympiadPageContext";

const useOlympiadPageContext = () => useContext(OlympiadPageContext);

export { useOlympiadPageContext };
